export default __webpack_public_path__ + "static/google-cloud-logo-4d60244c3e20ee44e0e197056e27cf4e.png";